var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "profile-section" },
    [
      _c("m-confirm", { ref: "confirm", attrs: { mode: "danger" } }),
      _c("m-profile-tab", {
        ref: "tabModal",
        attrs: {
          "profile-id": _vm.profileId,
          "profile-section": _vm.profileSection,
        },
        on: { created: _vm.onTabCreated, updated: _vm.onTabUpdated },
      }),
      _c("m-profile-field", {
        ref: "fieldModal",
        attrs: {
          tabs: _vm.tabs,
          fields: _vm.sectionFields,
          "profile-id": _vm.profileId,
        },
        on: { created: _vm.onFieldCreated, updated: _vm.onFieldUpdated },
      }),
      _c("m-move-field", {
        ref: "moveFieldModal",
        attrs: { tabs: _vm.tabs },
        on: { updated: _vm.onFieldMoved },
      }),
      _c(
        "div",
        { staticClass: "profile-section__actions" },
        [
          _c("c-button-dropdown", {
            staticClass: "profile-section__copy",
            attrs: {
              icon: "arrow",
              type: "dropdown",
              label: "Скопировать анкету",
              dropdown: {
                position: "left",
                items: _vm.otherProfileSections,
              },
            },
            on: { copy: _vm.copyProfile },
          }),
          _c("c-button", {
            staticClass: "profile-section__add-field",
            attrs: {
              size: "small",
              icon: { icon: "plus", color: "primary" },
              label: "Добавить поле",
              disabled: !_vm.tabs.length,
            },
            on: { click: _vm.createField },
          }),
          _c("c-button", {
            staticClass: "profile-section__add-tab",
            attrs: {
              size: "small",
              icon: { icon: "plus", color: "primary" },
              label: "Добавить вкладку",
            },
            on: { click: _vm.createTab },
          }),
        ],
        1
      ),
      _c(
        "draggable",
        {
          staticClass: "profile-section__tabs",
          attrs: {
            group: `profile-section-${_vm._uid}`,
            list: _vm.tabs,
            "force-fallback": true,
            "ghost-class": "tab-ghost",
          },
          on: { change: _vm.resortTabs },
        },
        _vm._l(_vm.tabs, function (tab) {
          return _c(
            "div",
            {
              key: tab.id,
              staticClass: "profile-tab",
              class: {
                "profile-tab--opened": tab.opened,
              },
            },
            [
              _c(
                "observer",
                {
                  staticClass: "profile-tab__header",
                  attrs: { disabled: true },
                },
                [
                  _c("toggler-button", {
                    attrs: { open: tab.opened, disabled: !tab.fields.length },
                    on: {
                      click: function ($event) {
                        tab.opened = !tab.opened
                      },
                    },
                  }),
                  _c("div", { staticClass: "profile-tab__name" }, [
                    _vm._v(" " + _vm._s(tab.name) + " "),
                    !tab.fields.length
                      ? _c("span", { staticClass: "empty" }, [
                          _vm._v("(пусто)"),
                        ])
                      : _vm._e(),
                  ]),
                  _c(
                    "div",
                    { staticClass: "profile-tab__actions" },
                    [
                      _c("c-button", {
                        directives: [
                          {
                            name: "b-popover",
                            rawName: "v-b-popover.html",
                            value: {
                              container: "#app",
                              trigger: "hover",
                              content: "Редактировать",
                              placement: "bottom",
                            },
                            expression:
                              "{\n              container: '#app',\n              trigger: 'hover',\n              content: 'Редактировать',\n              placement: 'bottom',\n            }",
                            modifiers: { html: true },
                          },
                        ],
                        staticClass: "profile-tab__edit",
                        attrs: { icon: "edit", size: "iconic" },
                        on: {
                          click: function ($event) {
                            return _vm.editTab(tab)
                          },
                        },
                      }),
                      _c("c-button", {
                        directives: [
                          {
                            name: "b-popover",
                            rawName: "v-b-popover.html",
                            value: {
                              container: "#app",
                              trigger: "hover",
                              content: "Удалить",
                              placement: "bottom",
                            },
                            expression:
                              "{\n              container: '#app',\n              trigger: 'hover',\n              content: 'Удалить',\n              placement: 'bottom',\n            }",
                            modifiers: { html: true },
                          },
                        ],
                        staticClass: "profile-tab__remove",
                        attrs: {
                          icon: { icon: "trash", color: "secondary" },
                          size: "iconic",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.deleteTab(tab)
                          },
                        },
                      }),
                      _c("c-button", {
                        directives: [
                          {
                            name: "b-popover",
                            rawName: "v-b-popover.html",
                            value: {
                              container: "#app",
                              trigger: "hover blur",
                              boundary: "window",
                              content: "Переместить",
                              placement: "top",
                            },
                            expression:
                              "{\n              container: '#app',\n              trigger: 'hover blur',\n              boundary: 'window',\n              content: 'Переместить',\n              placement: 'top',\n            }",
                            modifiers: { html: true },
                          },
                        ],
                        staticClass: "profile-tab__move",
                        attrs: { size: "iconic", icon: "arrows-constructor" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("transition", { attrs: { name: "slide" } }, [
                tab.opened
                  ? _c(
                      "div",
                      { staticClass: "profile-tab__fields" },
                      [
                        _c("profile-tab", {
                          attrs: { fields: tab.fields },
                          on: {
                            editField: function ($event) {
                              return _vm.editField($event, tab.id)
                            },
                            moveField: function ($event) {
                              return _vm.moveField($event, tab.id)
                            },
                            removeField: function ($event) {
                              return _vm.deleteField($event, tab.id)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ],
            1
          )
        }),
        0
      ),
      _vm.tabs.length
        ? _c(
            "div",
            {
              staticClass: "profile-section__footer",
              class: {
                fixed: _vm.fixFooter,
              },
            },
            [
              _c("c-button", {
                staticClass: "profile-section__add-field",
                attrs: {
                  size: "small",
                  icon: { icon: "plus", color: "primary" },
                  label: "Добавить поле",
                  disabled: !_vm.tabs.length,
                },
                on: { click: _vm.createField },
              }),
              _c("c-button", {
                staticClass: "profile-section__add-tab",
                attrs: {
                  size: "small",
                  icon: { icon: "plus", color: "primary" },
                  label: "Добавить вкладку",
                },
                on: { click: _vm.createTab },
              }),
              _c("observer", {
                staticClass: "footer-observer",
                on: {
                  fullyVisible: function ($event) {
                    _vm.fixFooter = false
                  },
                  fullyHidden: function ($event) {
                    _vm.fixFooter = true
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }